// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___BtfdP","foreground":"style__foreground___2Sjr8","strip":"style__strip___11F_1","textAuthor":"style__textAuthor___H9FUx","textDate":"style__textDate___2j1qC","deleteButton":"style__deleteButton___3dQRQ","deleteControls":"style__deleteControls___1qPnD","deleteControlsWhite":"style__deleteControlsWhite___2ILO0","deleteConfirm":"style__deleteConfirm___3OwxM","deleteText":"style__deleteText___3WcE1","deleteModelContainer":"style__deleteModelContainer___D5d9m","expandIcon":"style__expandIcon___1Ipqy"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/grid-item/style.css
// module id = 1241
// module chunks = 0